import BaseService from './BaseService'
import { CustomAxiosHeaders } from '../config/services'
import { requests } from '.'
import servicesConfig from '../config/services'

// use serviceName value below as key in `versions` object in `src/config/services.ts` for developer versions
const serviceName = 'LaunchpadService'
const host = servicesConfig.Launchpad
const opts: CustomAxiosHeaders = { host, serviceName }
const request = (addlOpts?: CustomAxiosHeaders) => {
  return requests(Object.assign({}, opts, addlOpts))
}

type ISegmentLocationQuery = {
  companyId: string
  locationId: string
  userId: string
}

type IUpdateStepAsCompletedQuery = {
  companyId: string
  locationId: string
  eventName: string
}

type ISegmentAgencyQuery = {
  companyId: string
  userId?: string
}

type IGetActionProgressQuery = {
  companyId: string
  userId: string
  segmentId: string
  type: string
  locationId?: string
  productId?: string
}

class LaunchpadService extends BaseService {
  constructor(baseUrl: string) {
    super(baseUrl, true)
  }
  segmentDetailForLocation = (params: ISegmentLocationQuery) =>
     this.requests.get(`/segments/location/details?companyId=${params.companyId}&locationId=${params.locationId}&userId=${params.userId}`)

  segmentDetailForAgency = (params: ISegmentAgencyQuery) =>
    this.requests.get(`/segments/agency/details?companyId=${params.companyId}&userId=${params.userId}`)

  updateStepAsCompleted = (body: IUpdateStepAsCompletedQuery) =>
    this.requests.put(`/segments/location/step-completed`, body)
  
  getActionProgress = (body: IGetActionProgressQuery) => {
    const { companyId, userId, segmentId, type, locationId = '', productId } = body
    let query = `companyId=${companyId}&userId=${userId}&segmentId=${segmentId}&type=${type}`
    
    if(locationId) query += `&locationId=${locationId}`
    if(productId) query += `&productId=${productId}`
    
    // console.log(`query: `, query)
    return this.requests.get(`/segments/action/progress?${query}`)
  }
}

const launchpadService = new LaunchpadService(BaseService.servicesConfig.Launchpad as string)

export default launchpadService

